import React from 'react';
import { MapPin } from 'lucide-react';
export function CoverageCallout() {
  return <section className="py-16 bg-gradient-to-br from-[#0D7377] to-[#14919B] text-white" data-id="element-112">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-113">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-white bg-opacity-20 rounded-full mb-6" data-id="element-114">
          <MapPin size={32} data-id="element-115" />
        </div>
        <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-116">
          UK Mainland Coverage
        </h2>
        <p className="text-xl text-gray-100 mb-8" data-id="element-117">
          We provide appliance repair services across England, Scotland, and
          Wales. Our network of qualified engineers ensures fast response times
          wherever you are.
        </p>
        <a href="tel:08000554969" className="inline-block bg-[#E8956B] text-white px-8 py-4 rounded-full font-semibold hover:bg-[#D67D54] transition-all shadow-lg hover:shadow-xl text-lg" data-id="element-118">
          Check Your Area
        </a>
      </div>
    </section>;
}